module.exports = __webpack_public_path__ + "static/media/dra-login.6b243b2e.webp";